import { render, staticRenderFns } from "./RadioYesNoInput.vue?vue&type=template&id=5b3fd778&scoped=true&lang=pug"
import script from "./RadioYesNoInput.vue?vue&type=script&lang=js"
export * from "./RadioYesNoInput.vue?vue&type=script&lang=js"
import style0 from "./RadioYesNoInput.vue?vue&type=style&index=0&id=5b3fd778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3fd778",
  null
  
)

export default component.exports